module.exports = __webpack_public_path__ + "img/edge_ev_coin.95c22625.svg";